import ConsultationUserSubordination from 'features/consultations/consultationUserSubordination';
import { useTitle } from '../helpers';

/**
 * @page Consultations subordinates page
 */

const ConsultationsSubordinationPage = () => {
  useTitle('Информация о подчинённом');

  return (
    <div>
      <h3>Страница информации о подчинённом</h3>
      <ConsultationUserSubordination />
    </div>
  );
};

export default ConsultationsSubordinationPage;
